import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconRegion(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M10.1667 4.33333L5.83333 3L1.83333 4.33333V13L5.83333 11.6667M10.1667 4.33333L14.1667 3V11.6667L10.1667 13L5.83333 11.6667M10.1667 4.33333V12.6667M5.83333 11.6667V3.33333"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
}
